import React, { useEffect, useState } from "react";
import "./ShopifyProducts.css"; // custom styles

const ShopifyProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load from environment variables
  const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_DOMAIN;
  const SHOPIFY_STOREFRONT_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
  const SHOPIFY_API_VERSION = process.env.REACT_APP_SHOPIFY_API_VERSION;

  const query = `
    {
      products(first: 12) {
        edges {
          node {
            id
            title
            handle
            description
            images(first: 1) {
              edges {
                node {
                  src: url
                  altText
                }
              }
            }
            variants(first: 1) {
              edges {
                node {
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(
          `https://${SHOPIFY_DOMAIN}/api/${SHOPIFY_API_VERSION}/graphql.json`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
            },
            body: JSON.stringify({ query }),
          }
        );

        const json = await res.json();
        if (json.errors) throw new Error(json.errors.map((e) => e.message).join(", "));

        setProducts(json.data.products.edges.map((e) => e.node));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [SHOPIFY_DOMAIN, SHOPIFY_STOREFRONT_TOKEN, SHOPIFY_API_VERSION]);

  if (loading) return <p className="loading-text">Loading products...</p>;
  if (error) return <p className="error-text">Error: {error}</p>;

  return (
    <section className="shopify-container">
      <h2 className="shopify-title">Our Products</h2>
      <div className="shopify-grid">
        {products.map((product) => {
          const img = product.images.edges[0]?.node.src;
          const price = product.variants.edges[0]?.node.price.amount;
          const currency = product.variants.edges[0]?.node.price.currencyCode;

          return (
            <a
              key={product.id}
              href={`https://${SHOPIFY_DOMAIN}/products/${product.handle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="shopify-card"
            >
              <div className="shopify-img-wrapper">
                {img ? (
                  <img
                    src={img}
                    alt={product.images.edges[0]?.node.altText || product.title}
                  />
                ) : (
                  <div className="shopify-no-img">No Image</div>
                )}
              </div>
              <div className="shopify-card-content">
                <h3 className="shopify-card-title">{product.title}</h3>
                <p className="shopify-card-desc">
                  {product.description || "No description available."}
                </p>
                <div className="shopify-card-footer">
                  <span className="shopify-price">
                    {price} {currency}
                  </span>
                  <span className="shopify-view-btn">View</span>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default ShopifyProducts;
